export const isAdmin = (authUser: { email?: string } | undefined) => {
  return (
    !!authUser &&
    (authUser.email === "niklas.lavrell@gmail.com" ||
      authUser.email === "soderquist.hanna@gmail.com")
  );
};
